import React from "react";
import { useAuth } from "../lib/auth";
import { ShieldAlert, LogOut } from "lucide-react";

export function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  if (!user?.impersonated_by) return null;
  const imp = user.impersonator;
  return (
    <div
      className="fixed top-0 left-0 right-0 h-10 mg-gradient-magical text-mg-navy text-sm font-semibold flex items-center justify-center gap-3 z-[60] shadow-sm"
      data-testid="impersonation-banner"
    >
      <ShieldAlert className="w-4 h-4" />
      <span>
        You are impersonating <strong>{user.name}</strong>
        {user.clinic?.name && <> from <strong>{user.clinic.name}</strong></>}.
        Actions are audited{user.impersonation_expires_at && <> · ends {new Date(user.impersonation_expires_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</>}
        {imp?.name && <> (Super Admin: {imp.name})</>}.
      </span>
      <button
        onClick={stopImpersonation}
        className="ml-3 bg-mg-navy text-white text-xs px-3 py-1.5 rounded-lg flex items-center gap-1.5 hover:bg-slate-900"
        data-testid="exit-impersonation-btn"
      >
        <LogOut className="w-3.5 h-3.5" /> Exit Impersonation
      </button>
    </div>
  );
}
